import "./CharCard.css";
import { useMemo } from "react";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../../../Services/AppInsightService";
import { IRpgCharacter } from "../../../models/IRpgCharacter";
import UiButton from "../../Buttons/UiButton";
import { getCharacterPortrait } from "../../../pages/Characters/characterHelpers";

interface ICharCardProps {
    character: IRpgCharacter;
	onView?: (characterId: number) => void;
	onEdit?: (characterId: number) => void;
	onDelete?: (characterId: number) => void;
}

const CharCard: React.FC<ICharCardProps> = (charProps) => {
    const { character, onView, onEdit, onDelete } = charProps;

	const portraitSrc = getCharacterPortrait(character);
    const raceClassText = useMemo(() => {
        const race = typeof character.Race === "string" ? character.Race.trim() : "";
        const clazz = typeof character.Class === "string" ? character.Class.trim() : "";

        const parts = [race, clazz].filter((p) => p.length > 0);
        return parts.length > 0 ? parts.join(" ") : "Race Unknown & Class Unknown";
    }, [character.Race, character.Class]);

    const lastPlayedText = useMemo(() => {
        const lplayed = character.LastPlayed;
        if (lplayed === null || lplayed === undefined) {
            return "Impatiently awaiting an Adventure";
        }

        const lpText = String(lplayed).trim();
        return lpText.length > 0 ? lpText : "Impatiently awaiting an Adventure";
    }, [character.LastPlayed]);

    return (
        <article className="char-card">
            {/* Portrait */}
            <div className="char-card__portrait">
                <img
                    alt={character.Name}
                    className="char-card__img"
                    src={portraitSrc}
                />
            </div>

            {/* Content */}
            <div className="char-card__body">
                <div className="char-card__header">
                    <div className="char-card__name">{character.Name}</div>
                    <div className="char-card__level">Level {character.Level}</div>
                </div>

                <div className="char-card__subtext">{raceClassText}</div>
                <div className="char-card__subtext">Last Played: {lastPlayedText}</div>

                {/* <!-- Action Buttons --> */}
                <div className="char-card__actions">
                    <UiButton
                        variant="blue"
                        size="compact"
                        text="View"
                        iconSrc="/images/Icons/view.svg"
                        iconAlt="View"
                        onClickCallback={() => onView?.(character.Id)}
                    />

                    <UiButton
                        variant="brown"
                        size="compact"
                        text="Edit"
                        iconSrc="/images/Icons/edit.svg"
                        iconAlt="Edit"
                        onClickCallback={() => onEdit?.(character.Id)}
                    />

                    <UiButton
                        variant="rust"
                        size="compact"
                        text="Delete"
                        iconSrc="/images/Icons/delete.svg"
                        iconAlt="Delete"
                        onClickCallback={() => onDelete?.(character.Id)}
                    />
                </div>
            </div>
        </article>
    );
}

export default withAITracking(reactPlugin, CharCard);
